import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e3b82684")

_pushScopeId("data-v-e3b82684")
const _hoisted_1 = { class: "element-animation-panel" }
const _hoisted_2 = {
  key: 0,
  class: "element-animation"
}
const _hoisted_3 = { class: "animation-pool" }
const _hoisted_4 = { class: "type-title" }
const _hoisted_5 = { class: "pool-item-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 图表元素暂不支持动画 ")
const _hoisted_7 = {
  key: 1,
  class: "element-animation",
  style: {"margin-top":"10px"}
}
const _hoisted_8 = { class: "animation-pool" }
const _hoisted_9 = { class: "type-title" }
const _hoisted_10 = { class: "pool-item-wrapper" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 图表元素暂不支持动画 ")
const _hoisted_12 = {
  key: 2,
  class: "tip"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 选中画布中的元素添加动画")
const _hoisted_14 = { class: "index" }
const _hoisted_15 = { class: "text" }
const _hoisted_16 = { class: "handler" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_IconEffects = _resolveComponent("IconEffects")
  const _component_Button = _resolveComponent("Button")
  const _component_Popover = _resolveComponent("Popover")
  const _component_IconClick = _resolveComponent("IconClick")
  const _component_Divider = _resolveComponent("Divider")
  const _component_IconPlayOne = _resolveComponent("IconPlayOne")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_IconCloseSmall = _resolveComponent("IconCloseSmall")
  const _component_Draggable = _resolveComponent("Draggable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.handleElement)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_ctx.handleElement.type !== 'chart')
            ? (_openBlock(), _createBlock(_component_Popover, {
                key: 0,
                trigger: "click",
                visible: _ctx.animationPoolVisible,
                "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.animationPoolVisible = $event))
              }, {
                content: _withId(() => [
                  _createVNode("div", _hoisted_3, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.animations, (type) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "pool-type",
                        key: type.name
                      }, [
                        _createVNode("div", _hoisted_4, _toDisplayString(type.name) + "：", 1),
                        _createVNode("div", _hoisted_5, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(type.children, (item) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "pool-item",
                              key: item.name,
                              onMouseenter: ($event: any) => (_ctx.hoverPreviewAnimation = item.value),
                              onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hoverPreviewAnimation = '')),
                              onClick: ($event: any) => (_ctx.addAnimation(item.value))
                            }, [
                              _createVNode("div", {
                                class: ["animation-box", [
                      'animate__animated',
                      'animate__faster',
                      _ctx.hoverPreviewAnimation === item.value && `animate__${item.value}`,
                    ]]
                              }, _toDisplayString(item.name), 3)
                            ], 40, ["onMouseenter", "onClick"]))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                default: _withId(() => [
                  _createVNode(_component_Button, { class: "element-animation-btn" }, {
                    default: _withId(() => [
                      _createVNode(_component_IconEffects, { style: {"margin-right":"5px"} }),
                      _createTextVNode(" " + _toDisplayString('入场动画：'+(_ctx.handleElementAnimation || '点击选择')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["visible"]))
            : (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: "element-animation-btn",
                disabled: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_IconEffects, { style: {"margin-right":"5px"} }),
                  _hoisted_6
                ]),
                _: 1
              }))
        ]))
      : _createCommentVNode("", true),
    (_ctx.handleElement)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          (_ctx.handleElement.type !== 'chart')
            ? (_openBlock(), _createBlock(_component_Popover, {
                key: 0,
                trigger: "click",
                visible: _ctx.animationPoolVisibleOut,
                "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.animationPoolVisibleOut = $event))
              }, {
                content: _withId(() => [
                  _createVNode("div", _hoisted_8, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.animationsOut, (type) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "pool-type",
                        key: type.name
                      }, [
                        _createVNode("div", _hoisted_9, _toDisplayString(type.name) + "：", 1),
                        _createVNode("div", _hoisted_10, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(type.children, (item) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "pool-item",
                              key: item.name,
                              onMouseenter: ($event: any) => (_ctx.hoverPreviewAnimationOut = item.value),
                              onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hoverPreviewAnimationOut = '')),
                              onClick: ($event: any) => (_ctx.addAnimationOut(item.value))
                            }, [
                              _createVNode("div", {
                                class: ["animation-box", [
                      'animate__animated',
                      'animate__faster',
                      _ctx.hoverPreviewAnimationOut === item.value && `animate__${item.value}`,
                    ]]
                              }, _toDisplayString(item.name), 3)
                            ], 40, ["onMouseenter", "onClick"]))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                default: _withId(() => [
                  _createVNode(_component_Button, { class: "element-animation-btn" }, {
                    default: _withId(() => [
                      _createVNode(_component_IconEffects, { style: {"margin-right":"5px"} }),
                      _createTextVNode(" " + _toDisplayString('出场动画：'+(_ctx.handleElementAnimationOut || '点击选择')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["visible"]))
            : (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: "element-animation-btn",
                disabled: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_IconEffects, { style: {"margin-right":"5px"} }),
                  _hoisted_11
                ]),
                _: 1
              }))
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_12, [
          _createVNode(_component_IconClick),
          _hoisted_13
        ])),
    _createVNode(_component_Divider),
    _createVNode(_component_Draggable, {
      class: "animation-sequence",
      modelValue: _ctx.animationSequence,
      animation: 300,
      scroll: true,
      scrollSensitivity: 50,
      onEnd: _ctx.handleDragEnd,
      itemKey: "id"
    }, {
      item: _withId(({ element, index }) => [
        _createVNode("div", {
          class: ["sequence-item", { 'active': _ctx.handleElement?.id === element.elId }]
        }, [
          _createVNode("div", _hoisted_14, _toDisplayString(index + 1), 1),
          _createVNode("div", _hoisted_15, "【" + _toDisplayString(element.elType) + "】" + _toDisplayString(element.animationType), 1),
          _createVNode("div", _hoisted_16, [
            _createVNode(_component_Tooltip, {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: "预览"
            }, {
              default: _withId(() => [
                _createVNode(_component_IconPlayOne, {
                  class: "handler-btn",
                  onClick: ($event: any) => (_ctx.runAnimation(element.elId, element.type))
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1032, ["mouseEnterDelay"]),
            _createVNode(_component_Tooltip, {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: "删除"
            }, {
              default: _withId(() => [
                _createVNode(_component_IconCloseSmall, {
                  class: "handler-btn",
                  onClick: ($event: any) => (_ctx.deleteAnimation(element.elId))
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1032, ["mouseEnterDelay"])
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["modelValue", "onEnd"])
  ]))
})